/* src/app/features/assets/components/asset-promo-catalogue/asset-promo-catalogue.scss */
:host {
  display: block;
  margin-bottom: 3.75rem;
}
.promo-catalogue .background-image {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: absolute;
}
.promo-catalogue .wrapper.clickable {
  cursor: pointer;
}
.promo-catalogue .wrapper {
  width: 100%;
  height: 480px;
  display: flex;
  flex-direction: row;
  position: relative;
  overflow: hidden;
}
.promo-catalogue .wrapper::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 65%;
  height: 100%;
  background:
    linear-gradient(
      90deg,
      var(--background_primary) 0%,
      transparent 90%);
  z-index: 1;
  pointer-events: none;
}
@media screen and (max-width: 800px) {
  .promo-catalogue .wrapper::before {
    width: 100%;
    background:
      linear-gradient(
        180deg,
        var(--background_primary) 0%,
        transparent 130%);
  }
}
@media screen and (max-width: 800px) {
  .promo-catalogue .wrapper {
    flex-direction: column;
    height: auto;
  }
  .promo-catalogue .wrapper .element {
    min-height: unset;
  }
  .promo-catalogue .wrapper .element.info {
    flex: none;
    max-width: 100%;
    width: 100%;
    padding: 40px 100px 20px;
    font-size: 11px !important;
    align-items: center !important;
    text-align: center;
  }
  .promo-catalogue .wrapper .element.info .subtitle-row {
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }
  .promo-catalogue .wrapper .element.info .subtitle-row badge {
    order: -1;
  }
  .promo-catalogue .wrapper .element.image {
    flex: none;
    max-width: 100%;
    width: 100%;
    padding: 0 30px 40px !important;
    align-items: center !important;
    justify-content: center;
  }
  .promo-catalogue .wrapper .element.image .image {
    margin: 0 auto !important;
  }
  .promo-catalogue .wrapper .element.image .image.landscape {
    width: 240px !important;
    height: 160px !important;
  }
  .promo-catalogue .wrapper .element.image .image.portrait {
    width: 160px !important;
    height: 214px !important;
  }
  .promo-catalogue .wrapper .element.image .image.square {
    width: 200px !important;
    height: 200px !important;
  }
  .promo-catalogue .wrapper .element.image .image.circle {
    width: 200px !important;
    height: 200px !important;
  }
}
.promo-catalogue .wrapper .element {
  position: relative;
  min-height: 300px;
  border-radius: 18px;
  align-items: center;
}
.promo-catalogue .wrapper .element.info {
  z-index: 1;
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
  align-items: normal;
  padding-left: 300px;
  flex: 1 1 calc(50% - 100px);
  max-width: calc(50% - 100px);
}
@media screen and (max-width: 1600px) {
  .promo-catalogue .wrapper .element.info {
    padding-left: 200px;
  }
}
@media screen and (max-width: 1366px) {
  .promo-catalogue .wrapper .element.info {
    flex: 1;
    max-width: none;
    padding-left: 100px;
    padding-right: 200px;
  }
}
@media screen and (max-width: 1024px) {
  .promo-catalogue .wrapper .element.info {
    padding-left: 100px;
    padding-right: 100px;
  }
}
.promo-catalogue .wrapper .element.image {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: end;
  padding-right: 300px;
  z-index: 1;
  flex: 1 1 calc(50% + 100px);
  max-width: calc(50% + 100px);
}
@media screen and (max-width: 1600px) {
  .promo-catalogue .wrapper .element.image {
    padding-right: 200px;
  }
}
@media screen and (max-width: 1366px) {
  .promo-catalogue .wrapper .element.image {
    flex: 0.5;
    max-width: none;
    padding-left: 100px;
    padding-right: 100px;
  }
}
@media screen and (max-width: 1024px) {
  .promo-catalogue .wrapper .element.image {
    padding-left: 100px;
    padding-right: 100px;
  }
}
.promo-catalogue .wrapper .element .subtitle-row {
  z-index: 1;
  display: flex;
  align-items: center;
}
.promo-catalogue .wrapper .element .subtitle {
  margin-right: 20px;
  z-index: 1;
  display: block;
  position: relative;
  color: var(--text_secondary);
  font-weight: bold;
}
@media screen and (max-width: 800px) {
  .promo-catalogue .wrapper .element .subtitle {
    margin-right: 0;
  }
}
.promo-catalogue .wrapper .element .title {
  z-index: 1;
  display: block;
  position: relative;
  line-height: 1;
}
.promo-catalogue .wrapper .element .description {
  z-index: 1;
  display: block;
  position: relative;
  margin-bottom: 16px;
}
.promo-catalogue .wrapper .element .button {
  max-width: fit-content;
}
.promo-catalogue .wrapper .element .button img {
  height: 50%;
}
.promo-catalogue .wrapper .element .image.outline {
  border: 4px solid var(--highlight_primary);
}
.promo-catalogue .wrapper .element .image {
  outline: none;
  background-size: cover;
  background-position: center;
  margin: auto 0;
}
.promo-catalogue .wrapper .element .image.landscape {
  width: 447px;
  height: 300px;
}
.promo-catalogue .wrapper .element .image.portrait {
  width: 300px;
  height: 402px;
}
.promo-catalogue .wrapper .element .image.square {
  width: 300px;
  height: 300px;
}
.promo-catalogue .wrapper .element .image.circle {
  width: 300px;
  height: 300px;
  border-radius: 50% !important;
}
@media screen and (max-width: 1366px) {
  .promo-catalogue .wrapper .element .image {
    margin: auto 0;
  }
  .promo-catalogue .wrapper .element .image.landscape {
    width: 280px;
    height: 200px;
  }
}
@media screen and (max-width: 1024px) {
  .promo-catalogue .wrapper .element .image {
    margin: auto 0;
  }
  .promo-catalogue .wrapper .element .image.landscape {
    width: 200px;
    height: 134px;
  }
  .promo-catalogue .wrapper .element .image.portrait {
    width: 200px;
    height: 268px;
  }
  .promo-catalogue .wrapper .element .image.square {
    width: 200px;
    height: 200px;
  }
  .promo-catalogue .wrapper .element .image.circle {
    width: 200px;
    height: 200px;
  }
}
/*# sourceMappingURL=asset-promo-catalogue.css.map */
